// ============================================================
// api/carePeopleRoles.js  (2b-13 Gate 5)
// Admin-portal client for the CarePeople module-role endpoints.
//
// Backend reference:
//   admin-carepeople-role-get.js    (GET    -> { coreRole, coreRoleApplicable, current, history })
//   admin-carepeople-role-grant.js  (POST   { carePeopleRole, roleScopeTier })
//   admin-carepeople-role-revoke.js (DELETE -> { revoked, carePeopleRole? })
//
// One path, three methods:
//   /api/mgmt/admin/users/{clientUserId}/carepeople-role
// ============================================================

import { apiGet, apiPost, apiDelete } from './client';

export async function getCarePeopleRole(clientUserId) {
  return apiGet(`/mgmt/admin/users/${clientUserId}/carepeople-role`);
}

export async function grantCarePeopleRole(clientUserId, { carePeopleRole, roleScopeTier }) {
  return apiPost(`/mgmt/admin/users/${clientUserId}/carepeople-role`, { carePeopleRole, roleScopeTier });
}

export async function revokeCarePeopleRole(clientUserId) {
  return apiDelete(`/mgmt/admin/users/${clientUserId}/carepeople-role`);
}
